import { useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'
import type { SprintActivityWherebyMeetingRequest } from '../../../../../../pure-js/types/WherebyTypes'
import { SprintCallQueryParam } from '../../../../config/routes/routeEnums'

/** The sprint and the activity whose call the page holds, read from its address so a refresh keeps the same call. */
export const useSprintCallRequest = (): SprintActivityWherebyMeetingRequest | undefined => {
  const [searchParams] = useSearchParams()
  const sprintId = searchParams.get(SprintCallQueryParam.SPRINT_ID)
  const activityId = searchParams.get(SprintCallQueryParam.ACTIVITY_ID)

  return useMemo(() => (sprintId && activityId ? { sprintId, activityId } : undefined), [sprintId, activityId])
}
